import { useEffect, useState } from "react";
import { useMatchesStore } from "../store/useMatchesStore";
import { Link, useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import useAuthStore from "../store/useAuthStore";

import location_dark from '../assets/images/location_dark.png';
import { useMatchStore } from "../store/useMatchStore";

import GradientCircularProgress from '../components/GradientCircularProgress';
import { useUserStore } from "../store/useUserStore";
import { getSizedImageUrl } from "../utils/getSizedImageUrl";
import default150 from '../assets/images/default150.png';



const MySwal = withReactContent(Swal);

const MatchesListPage = () => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const { rows, totalPages, loading, getMatches } = useMatchesStore();
  const {newRequest } = useUserStore();
    const { blockUser,
      reportUser } = useMatchStore();
  const authStore = useAuthStore.getState();
  const [resolvedImageMap, setResolvedImageMap] = useState<Record<string, string>>({});
  const [resolvedImageMap2, setResolvedImageMap2] = useState<Record<string, string>>({});


 useEffect(() => {
  
    getMatches(1); // fetch default page on mount

}, []);

useEffect(() => {
  (async () => {
    const entries = await Promise.all(
      rows.map(async (match) => {
        const url = match.user_photos_to[0]?.picture;
        const sizedUrl = url ? await getSizedImageUrl(url, '150x150') : match.user_to.pic;
        return [match.id, sizedUrl];
      })
    );
    const entries2 = await Promise.all(
      rows.map(async (match) => {
        const url = match.user_photos[0]?.picture;
        const sizedUrl = url ? await getSizedImageUrl(url, '150x150') : match.user.pic;
        return [match.id, sizedUrl];
      })
    );
    setResolvedImageMap(Object.fromEntries(entries));
    setResolvedImageMap2(Object.fromEntries(entries2));
  })();
}, [rows]);

  const handlePageChange = (newPage:any) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };
  useEffect(() => {
   
        getMatches(page);

  }, [page]);

  useEffect(() => {
    const interval = setInterval(async () => {
      if(newRequest.matchedCount>0 || newRequest.notificationsCount>0){
        getMatches(page);
      }
     
   }, 60000); // 60000 ms = 1 minute
  return () => clearInterval(interval); // Cleanup on unmount
  }, [newRequest?.matchedCount, newRequest?.notificationsCount, page]);


  const confirmBlockUser = async (userId:any, requestId:any, blockUser:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Block User?</h3>
          <p>Do you really want to block this user?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button className="btn btn-danger" onClick={async () => { 
              await blockUser(userId,requestId); 
               getMatches(1);
              MySwal.close();
            }}>
              Yes, Block
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };


  
  const confirmReportUser = (userId:any, reportUser:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Report User</h3>
          <p>Please enter the reason for reporting this user:</p>
          <textarea
            id="reportReason"
            className="form-control mb-3"
            placeholder="Enter your reason..."
            style={{ height: '100px', resize: 'none' }}
          ></textarea>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={() => {
                const reasonInput = document.getElementById('reportReason') as HTMLTextAreaElement;
                if (!reasonInput || !reasonInput.value.trim()) {
                  MySwal.showValidationMessage('Reason is required.');
                  return;
                }
                reportUser(userId, reasonInput.value.trim());
                MySwal.close();
                MySwal.fire('Reported!', 'The user has been reported successfully.', 'success');
              }}
            >
              Submit Report
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };  


  return (

    
    <section className="py-60 bg-light">
        <div className="container">
            <div className="row">
            {loading ? (
                <div className="text-center">
                  <div className="loader mb-2"></div>
                  <h5>Loading...</h5>
                </div>
              ) : rows.length === 0 ? (
                <>
                <h5 className="text-center">No matches found.</h5>
                      <h6 className="text-center">
                        Update your <Link to="/myprofile"><span className="text-primary">profile</span></Link> to stand out or go to{' '}
                        <Link to="/dashboard"><span className="text-primary">send likes</span></Link> to meet new singles.
                      </h6>
                    </>
                
              ) : (
          
                rows.map((match) => (
                    authStore.user?.id == match.from ? (
                      

                <div className="col-lg-11 position-relative m-auto">
                    <div className="card mb-4 mymatches_dp_item">
                        <div className="mymatches_dp_item_profile_info" onClick={() => navigate(`/messages/${match.id}`)}>
                            <div className="mymatches_dp_item_img_box">
                                <img src={resolvedImageMap[match.id] || match.user_to.pic || default150} alt="" className="img-fluid" />
                            </div>
                            <div>
                                <h2>{match.user_to.first_name}, {match.user_to.age}</h2>
                                <p className="mb-0">
                                    <img src={location_dark} className="me-2" />
                                    {match.user_to.city} {match.user_to.state}, {match.user_to.distance.toFixed(0)} miles away
                                </p>
                            </div>
                        </div>

                        <div className="d-flex flex-row align-items-center pe-md-4 mymatches_dp_item_action_wrpr">
                            <div className="mymatches_dp_item_actions" onClick={() => navigate(`/messages/${match.id}`)}>
                            {match.unread_message_count > 0 ?
                                <div className="dp_actions_btn_item">
                                
                                    <button className="btn message_btn" onClick={() => navigate(`/messages/${match.id}`)}>
                                        <i className="fa-solid fa-paper-plane"></i>
                                         <span className="badge bg-danger">{match.unread_message_count}</span> 
                                    </button>
                                    {match.unread_message_count} Unread message
                                </div>
                                : ''}
                                <div className=" text-center ">
                                  <h4>Love Diamond™ &nbsp; &nbsp; &nbsp;</h4>
                                  <div className="d-flex">
                                  <div className="dp_actions_btn_item dp_actions_btn_item-left" onClick={() => navigate(`/messages/${match.id}`)}>
                                    <GradientCircularProgress value={match?.from == authStore.user?.id ? match?.priority : match?.to_priority} id="your-interest" type='their_interest' />
                                    {/* Love Diamond™ Feature */}
                                    Your Interest
                                </div>  

                                <div className="dp_actions_btn_item dp_actions_btn_item-right" onClick={() => navigate(`/messages/${match.id}`)}>
                                    <GradientCircularProgress value={match?.from == authStore.user?.id ? match?.to_priority : match?.priority} id="their-interest" type='their_interest' />
                                
                                    Their Interest
                                </div>
                                </div>
                                </div>
                               
                            </div>
                            <i className="fa-solid fa-chevron-right" onClick={() => navigate(`/messages/${match.id}`)}></i>
                        </div>

                        <div className="dp_info_drpdwn_wrpr">
                            <button className="btn btn-sm dropdown-toggle dp_info_drpdwn" type="button" 
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" href="#" onClick={() => confirmBlockUser(match.user_to.id,match.id, blockUser)}>Block User</a></li>
                                <li><a className="dropdown-item" href="#" onClick={() => confirmReportUser(match.user_to.id, reportUser)}>Report</a></li>
                            </ul>
                        </div>
                    </div>

                  
                </div>
                 ) : (
                  <div className="col-lg-11 position-relative m-auto">
                    <div className="card mb-4 mymatches_dp_item">
                        <div className="mymatches_dp_item_profile_info" onClick={() => navigate(`/messages/${match.id}`)}>
                            <div className="mymatches_dp_item_img_box">
                              <img src={resolvedImageMap2[match.id] || match.user.pic || default150} alt="" className="img-fluid" />
                               
                            </div>
                            <div>
                                <h2>{match.user.first_name}, {match.user.age}</h2>
                                <p className="mb-0">
                                    <img src={location_dark} className="me-2" />
                                    {match.user.city} {match.user.state}, {match.user.distance.toFixed(0)} miles away
                                </p>
                            </div>
                        </div>

                        <div className="d-flex flex-row align-items-center pe-md-4 mymatches_dp_item_action_wrpr">
                            <div className="mymatches_dp_item_actions">
                            {match.unread_message_count > 0 ?
                                <div className="dp_actions_btn_item">
                                    <button className="btn message_btn" onClick={() => navigate(`/messages/${match.id}`)}>
                                        <i className="fa-solid fa-paper-plane"></i>
                                        <span className="badge bg-danger">{match.unread_message_count}</span>
                                    </button>
                                    {match.unread_message_count} Unread message
                                </div>
                                :
                                '' 
                                }
                                <div className="text-center">
                                  <h4>Love Diamond™ &nbsp; &nbsp; &nbsp;</h4>
                                  <div className="d-flex">
                                  <div className="dp_actions_btn_item dp_actions_btn_item-left" onClick={() => navigate(`/messages/${match.id}`)}>
                                    <GradientCircularProgress value={match?.from == authStore.user?.id ? match?.priority : match?.to_priority} id="your-interest" type='their_interest' />
                                    {/* Love Diamond™ Feature */}
                                    Your Interest
                                </div>  

                                <div className="dp_actions_btn_item dp_actions_btn_item-right" onClick={() => navigate(`/messages/${match.id}`)}>
                                    <GradientCircularProgress value={match?.from == authStore.user?.id ? match?.to_priority : match?.priority} id="their-interest" type='their_interest' />
                                
                                    Their Interest
                                </div>
                                </div>
                                </div>
                            </div>
                            <i className="fa-solid fa-chevron-right" onClick={() => navigate(`/messages/${match.id}`)}></i>
                        </div>

                        <div className="dp_info_drpdwn_wrpr">
                            <button className="btn btn-sm dropdown-toggle dp_info_drpdwn" type="button" 
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <ul className="dropdown-menu">
                            <li><a className="dropdown-item" href="#" onClick={() => confirmBlockUser(match.user.id, match.id, blockUser)}>Block User</a></li>
                            <li><a className="dropdown-item" href="#" onClick={() => confirmReportUser(match.user.id, reportUser)}>Report</a></li>
                            </ul>
                        </div>
                    </div>

                  
                </div>

                   )
                  ))
                )}
            </div>
                        {/* Pagination */}
                        <nav className="custom_pagination_wrapper">
                        <ul className="pagination">
                          <li className="page-item">
                            <a href="#" className="page-link" onClick={() => handlePageChange(page - 1)}>
                              <i className="fa-solid fa-chevron-left"></i>
                            </a>
                          </li>
                          {[...Array(totalPages)].map((_, index) => (
                            <li className={`page-item ${page === index + 1 ? "active" : ""}`} key={index}>
                              <a href="#" className="page-link" onClick={() => handlePageChange(index + 1)}>
                                {index + 1}
                              </a>
                            </li>
                          ))}
                          <li className="page-item">
                            <a className="page-link" onClick={() => handlePageChange(page + 1)}>
                              <i className="fa-solid fa-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
        </div>
       
    </section>



   
  );
};

export default MatchesListPage;
